import * as CL from '@design-system/component-library';
import { t } from '../../../common/i18n';
import { getContactInfoLines } from '../utils/placeOrderUtils';
import { StepButtons } from './common/StepButtons';
import type { ContactPerson } from '../../../generated/api/contactPerson';

import './CustomerStep.scss';

export interface CustomerInfoProps {
  contactInfo: ContactPerson;
  companyName: string;
  onNext: () => void;
}

export const CustomerStep = ({ contactInfo, companyName, onNext }: CustomerInfoProps) => {
  const handleNext = async () => {
    onNext();
  };

  return (
    <>
      <div className="of-place-order__customer-step">
        <h2>{t.NF60('Customer details')}</h2>
        <CL.Description
          items={[
            {
              title: companyName,
              description: getContactInfoLines(contactInfo).map((line, index) => <div key={index}>{line}</div>),
            },
          ]}
        />
      </div>
      <StepButtons onNext={handleNext} />
    </>
  );
};
